import { api } from "./config";


export const getTreatmentsNoLimit = async (queryFields: string, additionalFilter?: any) => {
        const filter = {
            _and: [{ treatment_status_new: { _eq: "all_good" } }, additionalFilter ? additionalFilter : {}],
        };
        
        const response = await api({
        method: "GET",
        params: {
            fields: queryFields,
            filter: JSON.stringify(filter),
            limit: -1,
            deep: {
                sessions: {
                    _limit: -1, // This will remove the limit on sessions
                },
            },
        },
        url: "/items/treatments",
    });

    const items = response.data.data;
    const metadata = response.data.meta;
    
    return { items, metadata };
}